/** xl breakpoint grid: 5 columns × 4 rows per batch */
export const EVENT_GRID_COLUMNS = 5;
export const EVENT_GRID_ROWS_PER_BATCH = 4;
export const EVENTS_BATCH_SIZE = EVENT_GRID_COLUMNS * EVENT_GRID_ROWS_PER_BATCH;

/** Place sentinel after row 1 so the next batch loads before the user reaches row 3 */
export const INFINITE_SCROLL_SENTINEL_AFTER_INDEX = EVENT_GRID_COLUMNS - 1;

/** Preload when sentinel is still far below the fold */
export const INFINITE_SCROLL_ROOT_MARGIN = '520px';

export const API_BASE = import.meta.env.VITE_API_URL || 'http://localhost:5000';
